import React from 'react'

const Footer = (props) => {
	return (
		<footer className="section footer">
			<div className="footer-left">
				Copyright © 2021 <strong>ÖDEDİM</strong>. Tüm hakları saklıdır. <div className="footer-terms"><a href="https://odedim.com/gizlilik-politikasi/" className="link" target="_blank" rel="noopener noreferrer">Kullanım Koşulları</a><span>|</span><a href="https://odedim.com/gizlilik-politikasi/" className="link" target="_blank" rel="noopener noreferrer">Gizlilik Sözleşmesi</a></div>
			</div>
			<div className="footer-right">
				<a className="link" href="http://positive.com.tr" target="_blank" rel="noopener noreferrer">Positive a Digital Approach ®</a>
			</div>
		</footer>
	)
}

export default Footer